module.exports = __webpack_public_path__ + "6a3f60feffa0a7b2e4b00cc6f67d6c69.pdf";